





































































import Vue from "vue";
import AiLoadingAnimation from "./AiLoadingAnimation.vue";
import { FollowUpQuestionDto } from "@/types/ai/aiSearch";
import AiDisclaimer from "./AiDisclaimer.vue";
import AiFeedback from "./AiFeedback.vue";

export default Vue.extend({
    name: "AiAnswer",
    components: { AiLoadingAnimation, AiDisclaimer, AiFeedback },
    props: {
        aiAnswer: {
            required: true,
            default: () => undefined
        },
        contentItemId: {
            type: String,
            default: () => null
        },
        searchScope: {
            type: String,
            default: () => null
        }
    },
    data: () => ({
        openPanelId: 0
    }),
    computed: {
        isLoadingAnswer(): boolean {
            return this.aiAnswer === undefined;
        },
        notFound(): boolean {
            return this.aiAnswer?.status == "not_found";
        },
        isAnswerEmpty(): boolean {
            return this.aiAnswer?.answer == "" && this.aiAnswer.suggested_follow_up_questions?.length == 0 && this.isLoadingAnswer === false;
        },
        canShowAnswer(): boolean {
            if (!this.isAnswerEmpty && this.aiAnswer?.is_question && this.aiAnswer?.is_question_answerable) {
                return true;
            }
            return false;
        },
        hasfollowUpQuestions(): boolean {
            return this.allowedSuggestedQuestions.length > 0;
        },
        allowedSuggestedQuestions(): FollowUpQuestionDto[] {
            if (
                this.aiAnswer == null ||
                this.aiAnswer?.suggested_follow_up_questions == null ||
                this.aiAnswer?.suggested_follow_up_questions?.length == 0
            ) {
                return [];
            }

            return this.aiAnswer?.suggested_follow_up_questions?.filter(suggested_follow_up_question => {
                return (
                    suggested_follow_up_question.question != "" &&
                    suggested_follow_up_question.question != null &&
                    suggested_follow_up_question.answer != "" &&
                    suggested_follow_up_question.answer != null
                );
            });
        }
    }
});
